export default "__VITE_ASSET__DXSv3RGL__"